<div class="dialog-danger">
    <div class="modal-body">
        <span>{{ message }}</span>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn" (click)="confirm()" translate>general.yes</button>
        <button type="button" class="btn" (click)="dismiss()" translate>general.no</button>
    </div>
</div>
